export class ApplicationSidenav {

    private sideNav: Element;
    private sideNavContent: Element;
    private sideNavOverlay: Element;
    private preloader: Element;
    private sideNavButtons: Element;

    private appList: string[] = [];

    private currentAppId: string;
    private nextAppId: string;
    private prevAppId: string;
    private isLoading: boolean;
    
    constructor() {
        this.createSideNav();
        window.addEventListener('popstate', () => {
            this.checkOpenSidenav();
        });
    }

    public checkOpenSidenav(): void {
        const currentUrl = new URL(window.location.href);
        if (currentUrl.pathname === '/services/software/product' && currentUrl.searchParams.get('code') && currentUrl.searchParams.get('appid')) {  
            this.currentAppId = currentUrl.searchParams.get('appid');
            this.openSidenav();
            this.loadAppData();
        } else {
            this.closeSideNav(false);
        }
    }

    private getAppList(): void {
        const applicationsTable = document.getElementById('applicationsList');
        if (!applicationsTable) {
            return;
        }
        const applicationsList = applicationsTable.getAttribute('data-app-list');
        if (applicationsList) {
            this.appList = JSON.parse(applicationsList);
            this.setPrevAndNextApp();
        }
    }

    private setPrevAndNextApp(): void {
        if (this.appList.length < 2) {
            this.changeButtonsVisibility(true);
            return;
        }

        this.changeButtonsVisibility();
        const currentAppPosition = this.appList.indexOf(this.currentAppId);
        this.prevAppId = currentAppPosition === 0 ? this.appList[this.appList.length - 1] : this.appList[currentAppPosition - 1];
        this.nextAppId = currentAppPosition === this.appList.length - 1 ? this.appList[0] : this.appList[currentAppPosition + 1];
    }

    private changeButtonsVisibility(isHidden: boolean = false): void {
        if (isHidden) {
            this.sideNavButtons.classList.add('app-description__buttons_is-hidden');
        } else {
            this.sideNavButtons.classList.remove('app-description__buttons_is-hidden');
        }
    }

    private openSidenav(): void {
        this.sideNav.classList.add('app-description_is-opened');
        this.sideNavOverlay.classList.add('side-nav-overlay_is-open');
        document.documentElement.style.setProperty('overflow', `hidden`);
        document.body.style.setProperty('overflow', `hidden`);
    }

    private createSideNav(): void {
        this.sideNav = document.getElementById('sideNav');
        this.sideNavOverlay = document.getElementById('sideNavOverlay');
        this.preloader = document.getElementById('sideNavPreloader');
        this.sideNavContent = document.getElementById('sideNavContent');
        this.sideNavButtons = document.getElementById('sideNavButtons');

        this.sideNavOverlay.addEventListener('click', () => { this.closeSideNav(true); });
        document.getElementById('sideNavButtonLeft').addEventListener('click', () => { this.goToNextApp(this.prevAppId); });
        document.getElementById('sideNavButtonRight').addEventListener('click', () => { this.goToNextApp(this.nextAppId); });
        document.getElementById('sideNavExit').addEventListener('click', () => { this.closeSideNav(true); });

        this.getAppList();
        this.checkOpenSidenav();
    }

    private fillSideNavContent(content) {
        this.createSimpleElement('app-description__title', this.sideNavContent, content.title);
        this.createSimpleElement('app-description__business-line', this.sideNavContent, content.businessLine);
        this.createSimpleElement('app-description__section', this.sideNavContent, content.section);
        this.createSimpleElement('app-description__description', this.sideNavContent, content.description);
        this.createSimpleElement('content-block app-description__text', this.sideNavContent, content.content);
    }

    private fillSideNavErrorContent(error): void {
        this.createSimpleElement('app-description__error', this.sideNavContent, `Упс, ${error} ошибочка(`);
    }

    private createSimpleElement(className: string, parent: Element, content: string = ''): void {
        let element = document.createElement('div');
        element.className = className;
        element.innerHTML = content;
        parent.appendChild(element);
    }

    private goToNextApp(appId: string): void {
        if (this.isLoading) {
            return;
        }
        
        this.currentAppId = appId;
        this.loadAppData();
        this.changeUrl();
    }

    private changeUrl(): void {
        const currentUrl = new URL(window.location.href);
        let newUrl = `${currentUrl.pathname}?code=${currentUrl.searchParams.get('code')}`;
        newUrl += this.currentAppId ? `&appid=${this.currentAppId}${currentUrl.hash}` : currentUrl.hash;
        history.pushState(newUrl, '', newUrl);
    }

    private closeSideNav(isNeedChangeUrl: boolean): void {
        this.currentAppId = null;
        this.sideNavContent.innerHTML = '';
        if (isNeedChangeUrl) {
            this.changeUrl();
        }
        this.sideNav.classList.remove('app-description_is-opened');
        this.sideNavOverlay.classList.remove('side-nav-overlay_is-open');
        document.documentElement.style.setProperty('overflow', `auto`);
        document.body.style.setProperty('overflow', `auto`);
    }

    private changePreloaderState(isActive: boolean = false): void {
        if (isActive) {
            this.preloader.classList.add('app-description__preloader_is-active');
        } else {
            this.preloader.classList.remove('app-description__preloader_is-active');
        }
    }

    private loadAppData(): void {
        this.changePreloaderState(true);
        this.isLoading = true;
        this.sideNavContent.innerHTML = '';
        this.createRequest(`/api/v1/application?code=${this.currentAppId}`, { method: 'GET' })
            .then(response => {
                this.setPrevAndNextApp();
                this.fillSideNavContent(response);
                this.changePreloaderState();
                this.isLoading = false;
            })
            .catch(err => {
                this.changePreloaderState();
                this.fillSideNavErrorContent(err);
                this.isLoading = false;
            });
    }

    private createRequest = (url, options) => {
        return window.fetch(url, {
          headers: new Headers({
            Accept: "application/json",
            "Content-Type": "application/json"
          }),
          method: options.method || "GET",
        }).then(response => {
          if (response.status === 200) {
            return response.json();
          } else {
            throw response.status;
          }
        });
      };
}
